import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';

import Button, {ButtonStyle} from 'ui-library/buttons/Button';

interface ResetToDefaultsButtonProps {
  resetOnClick: () => void;
}

/**
 * A button that resets assembly parameters to their default values.
 * @param {ResetToDefaultsButtonProps} props Component props
 * @param {function} props.resetOnClick A function that resets parameters to default in state.
 * @constructor
 */
export function ResetToDefaultsButton(props: ResetToDefaultsButtonProps): JSX.Element {
  return (
    <Button
      className={css(styles.rightAlign)}
      buttonStyle={ButtonStyle.LINK}
      text="Reset to defaults"
      onClick={() => {
        props.resetOnClick();
      }}
    />
  );
}

const styles = StyleSheet.create({
  rightAlign: {
    float: 'right',
  },
});
